module.exports = __webpack_public_path__ + "img/logo-whatsapp.1d51557a.svg";